import React from 'react'
import ModalDrawer from '../../../common/components/organisme/ModalDrawer/ModalDrawer'

export const MODAL_ID_PAYGO = "create-paygo-modal"

export default function CreatePayGoPage() {
  return (
    <div>
      <p> page </p>
    </div>
  )
}


export const CreatePayGoPageDrawer = () => (
    <ModalDrawer title="Create PayGo" urlParamName={MODAL_ID_PAYGO}> 
        <CreatePayGoPage />
    </ModalDrawer>

)